// extracted by mini-css-extract-plugin
export default {"postsWrapper":"pinsSection_postsWrapper__pWr0O"};